module.exports = __webpack_public_path__ + "img/category-Biography.191cc422.svg";